import Vue from 'vue';
import Router from 'vue-router';
import Comments from './views/Comments.vue';
import Promotions from './views/Promotions.vue';
import Statistics from './views/Statistics.vue';
import ProfileDashboard from './views/ProfileDashboard.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/promotions'
    },
    {
      path: '/comments',
      name: 'comments',
      component: Comments
    },
    {
      path: '/promotions',
      name: 'promotions',
      component: Promotions
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: Statistics
    },
    {
      path: '/profile',
      name: 'profile',
      component: ProfileDashboard
    }
  ]
});
